import AddEditProcedureModal from './AddEditProcedureModal';

export default AddEditProcedureModal;
